import { Injectable } from "@angular/core";
import {
  ActivationEnd,
  NavigationEnd,
  Router,
  NavigationExtras,
} from "@angular/router";

/**
 * @Purpose State Management
 * @LastUpdate 14 October 2020
 */
@Injectable()
export class NavigationService {
  public lastValue: any;
  public newValue: any;
  public animationValue: any;
  public navigationHistory: any[] = [];
  public temp = "";
  isBack : boolean = false;

  constructor(private router: Router) {
    if (this.navigationHistory?.length == 0) {
      let history = sessionStorage.getItem("navigationHistory");
      if (history) this.navigationHistory = JSON.parse(history);
    }
    this.router.events.subscribe((event) => {
      if (event instanceof ActivationEnd) {
        const snapshot = event.snapshot;
        if(snapshot.data.reset){
          this.clearState();
        }
        if (snapshot.data.num) {
          this.lastValue = this.newValue;
          this.newValue = snapshot.data.num;
          this.animationValue = this.getAnimationNumber(
            this.lastValue,
            this.newValue
          );
        }
      }
      if (event instanceof NavigationEnd) {
        // If the state is empty and the session storage is not null
        if (
          this.navigationHistory?.length == 0 &&
          sessionStorage.getItem("navigationHistory")
        ) {
          // Get all the state from session storage
          this.navigationHistory = JSON.parse(
            sessionStorage.getItem("navigationHistory")
          );
        }

        let temp : any = null;

        // Check is last of the state is same or not
        if (
          this.getUrl(
            this.navigationHistory[this.navigationHistory?.length-1]?.url
          ) == this.getUrl(event.url)
        ) {
          //remove the last state
        temp = this.navigationHistory.pop();
        }

        // Push the state
        if(this.temp){
          this.navigationHistory.push({url : event.url , state:  this.temp});
        }else {
            this.navigationHistory.push({url : event.url , state: temp?.state  || ""});
        }
        this.temp = ""
        // Update the state into session storage
        sessionStorage.setItem(
          "navigationHistory",
          JSON.stringify(this.navigationHistory)
        );
      }
    });
  }

  getAnimationNumber(lastValue: number, newValue: number) {
    let result = 0;
    if (lastValue && newValue) {
      result = 2;
      if (lastValue) {
        if (newValue > lastValue) {
          result = 2;
        } else {
          result = 1;
        }
      } else {
        result = 1;
      }
    }
    return result;
  }

  /** Back to pervious page . If no previous page, will default back to dashboard */
  public backPerviousPage(router: boolean = true) {
    // Will remove current state
    this.navigationHistory.pop();

    // Will remove previous state
    let perviousPage = this.navigationHistory.pop();
    this.temp = perviousPage?.state;
    this.isBack = true;

    // Check if previous state is same as current state will remove on more layer to ensure no duplicate
    if (this.getUrl(this.router.url) == this.getUrl(perviousPage?.url)) {
      perviousPage = this.navigationHistory.pop();
    }

    // Prepare the params
    if (router) {
      let navigationExtras: NavigationExtras = {
        queryParams: this.getURLParameters(perviousPage?.url),
      };
      this.router.navigate([this.getUrl(perviousPage?.url)], navigationExtras);
    }
  }

  /** To clear all the state and remove the session storage state */
  public clearState() {
    this.navigationHistory = [];
    sessionStorage.removeItem("navigationHistory");
  }

  /** To get the base url */
  public getUrl(url: string): string {
    if (!url) return "/";
    let urls = url?.split("?");
    return urls[0];
  }

  /** To get the url parameters */
  public getURLParameters(url: string) {
    if (!url) return {};
    let urls = url.split("?");
    if (urls.length < 2) return {};

    url = urls[1];
    return JSON.parse(
      '{"' + url.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
      function (key, value) {
        return key === "" ? value : decodeURIComponent(value);
      }
    );
  }

  public isNavigationExist(path: string) {
    let temp = this.navigationHistory.map((history)=>history.url);
    return temp.some((x) => x.search(path) != -1);
  }

  public removePreviousPage() {
    // Will remove current state
    this.navigationHistory.pop();

    // Will remove previous state
    let perviousPage = this.navigationHistory.pop();

    // Check if previous state is same as current state will remove on more layer to ensure no duplicate
    if (this.getUrl(this.router.url) == this.getUrl(perviousPage.url)) {
      perviousPage = this.navigationHistory.pop();
    }
  }

  public setState(state){
    if(!this.isBack)
    this.navigationHistory[this.navigationHistory.length-1].state = state || "";
  }

  public getState(){
    this.isBack = false;
    return this.navigationHistory[this.navigationHistory.length -1]?.state || "";
  }
}
